import { Command } from '../../entities/commands-v1/command';
import { FileTypeConfig } from '../../entities/file-type-configurations-v1/models';

export enum commandsActionNames {
  SET_COMMANDS = 'SET_COMMANDS',
  CLEAR_COMMANDS = 'CLEAR_COMMANDS',
  SET_TOTAL_COUNT = 'SET_TOTAL_COUNT',
  SET_NEXT_CURSOR = 'SET_NEXT_CURSOR',
  SHOW_DEVICE_CONFIGURATION = 'SHOW_DEVICE_CONFIGURATION',
  HIDE_DEVICE_CONFIGURATION = 'HIDE_DEVICE_CONFIGURATION',
  SET_FILE_TYPE_CONFIGS = 'SET_FILE_TYPE_CONFIGS',
}

export interface CommandsState {
  commands: Command[] | [];
  nextCursor: string;
  count: number;
  showDeviceConfiguration: boolean;
  fileTypeConfigs: Array<FileTypeConfig> | [];
}

interface SetCommandsAction {
  type: typeof commandsActionNames.SET_COMMANDS;
  payload: Command[];
}

interface SetTotalCount {
  type: typeof commandsActionNames.SET_TOTAL_COUNT;
  payload: number;
}

interface SetNextCursor {
  type: typeof commandsActionNames.SET_NEXT_CURSOR;
  payload: string;
}

interface ClearCommands {
  type: typeof commandsActionNames.CLEAR_COMMANDS;
}

interface ShowDeviceConfiguration {
  type: typeof commandsActionNames.SHOW_DEVICE_CONFIGURATION;
}

interface HideDeviceConfiguration {
  type: typeof commandsActionNames.HIDE_DEVICE_CONFIGURATION;
}

interface SetFileTypeConfigs {
  type: typeof commandsActionNames.SET_FILE_TYPE_CONFIGS;
  payload: Array<FileTypeConfig>;
}

export type CommandsActionTypes =
  | SetCommandsAction
  | SetTotalCount
  | SetNextCursor
  | ClearCommands
  | ShowDeviceConfiguration
  | HideDeviceConfiguration
  | SetFileTypeConfigs;
